export default "__VITE_ASSET__CnEUy0cT__"